<template>
  <div class="container-box">
    <!-- 基础信息 -->
    <div class="hearder-title">
      <div class="flex_between">
        <img class="title-icon" src="@/assets/svg/bsaicIcon.svg" alt="dark" />
        基础信息
      </div>
    </div>
    <div class="form-container">
      <!-- 表单内容 -->
      <el-form
        :inline="true"
        v-if="!isLookOperate"
        :model="qualityData"
        label-width="85px"
      >
        <!-- 反馈单号 -->
        <el-form-item label="反馈单号">
          <el-input
            disabled
            v-model="qualityData.feedbackFormId"
          ></el-input>
        </el-form-item>
        <!-- 所属经销商 -->
        <!-- <el-form-item label="所属经销商">
          <el-input disabled v-model="qualityData.customerName"></el-input>
        </el-form-item> -->
        <!-- 国家 -->
        <el-form-item label="国家">
          <el-select disabled filterable clearable v-model="qualityData.countryDataId">
            <el-option
              v-for="item in countryList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-descriptions :column="3" border v-else>
        <el-descriptions-item label="反馈单号">
          {{ qualityData.feedbackFormId }}
        </el-descriptions-item>
        <!-- <el-descriptions-item label="所属经销商">
          {{qualityData.customerName}}
        </el-descriptions-item> -->
        <el-descriptions-item label="国家">
          <div v-for="item in countryList" :key="item.id">
            <div v-if="item.id == qualityData.countryDataId">
              {{ item.name }}
            </div>
          </div>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <!-- 车辆信息 -->
    <div class="hearder-title">
      <div class="flex_between">
        <img class="title-icon" src="@/assets/svg/carInfo.svg" alt="dark" />
        车辆信息
      </div>
    </div>
    <div class="form-container" style="border-bottom: none">
      <el-form
        v-if="!this.isLookOperate"
        ref="form"
        :inline="true"
        :model="qualityData"
        :rules="formRules"
        label-width="85px"
      >
        <!-- VIN码 -->
        <el-form-item label="VIN码" prop="vin">
          <el-input
            v-model="qualityData.vin"
            placeholder="请输入VIN码"
            @blur="handleBlur"
            @focus="handleFocus"
            @change="getCarModel"
          />
        </el-form-item>
        <!-- 车型 -->
        <el-form-item label="车型" prop="carModel">
          <el-input v-model="qualityData.carModel" placeholder="请输入车型"/>
        </el-form-item>
        <!-- 车辆属性 -->
        <el-form-item label="车辆属性" prop="carAttribute">
          <el-select filterable clearable v-model="qualityData.carAttribute">
            <el-option label="燃油车" :value="0"> </el-option>
            <el-option label="电动车" :value="1"> </el-option>
          </el-select>
        </el-form-item>

        <!-- 销售日期 -->
        <el-form-item label="销售日期" prop="saleDate">
          <el-date-picker
            type="date"
            value-format="yyyy-MM-dd"
            v-model="qualityData.saleDate"
            placeholder="请选择"
          ></el-date-picker>
        </el-form-item>
        <!-- 生产日期 -->
        <el-form-item label="生产日期" prop="productionDate">
          <el-date-picker
            type="date"
            value-format="yyyy-MM-dd"
            v-model="qualityData.productionDate"
            placeholder="请选择"
          ></el-date-picker>
        </el-form-item>
        <!-- 行驶里程 -->
        <el-form-item label="行驶里程" prop="drivingDistance">
          <el-input-number
            class="number-input"
            :controls="false"
            :precision="0"
            v-model="qualityData.drivingDistance"
            placeholder="请输入"
          >
          </el-input-number>
          <div class="number-input-append">km</div>    
        </el-form-item>
      </el-form>
      <el-descriptions :column="3" border v-else>
        <el-descriptions-item label="VIN码">{{
          qualityData.vin
        }}</el-descriptions-item>
        <el-descriptions-item label="车型">{{
          qualityData.carModel
        }}</el-descriptions-item>
        <el-descriptions-item label="车辆属性">
          {{ qualityData.carAttribute == 0 ? "燃油车" : "电动车" }}
        </el-descriptions-item>
        <el-descriptions-item label="销售日期">{{
          qualityData.saleDate
        }}</el-descriptions-item>
        <el-descriptions-item label="生产日期">{{
          qualityData.productionDate
        }}</el-descriptions-item>
        <el-descriptions-item label="行驶里程"
          >{{ qualityData.drivingDistance }}km</el-descriptions-item
        >
      </el-descriptions>
    </div>

    <div>
      <!-- 故障信息 -->
      <div class="hearder-title">
        <div class="flex_between">
          <img class="title-icon" src="@/assets/svg/faultIcon.svg" alt="dark" />
          故障信息
        </div>
      </div>
      <!-- 表格搜索条件表单 -->
      <!-- <div class="filter-container" v-if="isLookOperate">
        <el-form :inline="true" :model="queryParams" label-width="85px">
          <el-form-item label="故障描述">
            <el-input v-model="queryParams.questionContent" placeholder="请输入故障描述"></el-input>
          </el-form-item>
          <el-button class="primary-btn" type="primary" @click="doSearch">
              <i class="subSearch-icon"></i>
              查询
            </el-button>
            <el-button class="primary-btn" icon="el-icon-refresh-right" plain @click="handleResetQuery">
              重置
            </el-button>
        </el-form>
      </div> -->
      <!-- 表格内容 -->
      <div class="table-container">
        <div class="table-btn" v-if="!isLookOperate">
          <!-- 新增问题 -->
          <el-button
            class="primary-btn"
            type="text"
            icon="el-icon-plus"
            size="small"
            @click="handleAddOrEdit('新增问题')"
            >新增问题</el-button
          >
        </div>
        <el-table
          ref="tableRef"
          :border="true"
          stripe
          :data="tableData"
        >
          <!-- 序号 -->
          <el-table-column label="序号" width="60px" align="center">
            <template slot-scope="scope">
              {{ getColumnIndex(scope.$index) }}
            </template>
          </el-table-column>
          <!-- 问题序号 -->
          <el-table-column
            prop="questionNum"
            label="问题序号"
            min-width="130px"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-if="isLookOperate"
                class="lineTheme"
                @click="handleLook(scope.row)"
                >{{ scope.row.questionNum }}</span
              >
              <span v-else>{{ scope.row.questionNum }}</span>
            </template>
          </el-table-column>
          <!-- 是否重点问题 -->
          <el-table-column
            prop="importantType"
            label="是否重点问题"
            width="110px"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.importantType == 1" style="color: #f56c6c"
                >是</span
              >
              <span v-if="scope.row.importantType == 0">否</span>
            </template>
          </el-table-column>
          <!-- 故障描述 -->
          <el-table-column
            prop="questionContent"
            label="故障现象描述"
            min-width="200px"
            show-overflow-tooltip
          >
          </el-table-column>
          <!-- 重复性 -->
          <el-table-column
            property="repeatability"
            label="重复性"
            width="100px"
            align="center"
            v-if="isLookOperate"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.repeatability == 0">一直存在</div>
              <div v-if="scope.row.repeatability == 1">偶发</div>
            </template>
          </el-table-column>
          <!-- 故障发生日期 -->
          <el-table-column
            prop="happenDate"
            label="故障发生日期"
            min-width="160px"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <!-- 状态 -->
          <!-- <el-table-column
            prop="status"
            label="状态"
            width="120px"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0">待提交</span>
              <span class="blueColor" v-if="scope.row.status == 1">处理中</span>
              <span class="warnColor" v-if="scope.row.status == 2">待确认</span>
              <span clas="redColor" v-if="scope.row.status == 3">被驳回</span>
              <span class="successColor" v-if="scope.row.status == 4">已关闭</span>
            </template>
          </el-table-column> -->
          <!-- 零部件类别 -->
          <!-- <el-table-column
            prop="componentCategory"
            label="零部件类别"
            min-width="200px"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column> -->

          <!-- 零部件批次信息 -->
          <!-- <el-table-column
            prop="componentBatchs"
            label="零部件批次信息"
            min-width="200px"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column> -->

          <!-- 订单号 -->
          <!-- <el-table-column
            prop="orderNumber"
            label="订单号"
            min-width="200px"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column> -->

          <!-- 订单数量 -->
          <!-- <el-table-column
            prop="orderQuantity"
            label="订单数量"
            min-width="200px"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column> -->

          <!-- 故障数量 -->
          <!-- <el-table-column
            prop="faultNumber"
            label="故障数量"
            min-width="200px"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column> -->
          <!-- 操作 -->
          <el-table-column label="操作" width="110px"  align="center" fixed="right">
            <template slot-scope="scope">
              <!-- 查看 -->
              <el-button
                v-if="isLookOperate"
                size="mini"
                type="text"
                @click="handleLook(scope.row)"
                >查看</el-button
              >
              <!-- 编辑 -->
              <el-button
                v-if="!isLookOperate"
                size="mini"
                type="text"
                @click="handleAddOrEdit('编辑问题', scope.row, scope.$index)"
                >编辑</el-button
              >
              <!-- 删除 -->
              <el-button
                v-if="!isLookOperate"
                size="mini"
                type="text"
                @click="handleDelete(scope.row, scope.$index)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="fenye" v-show="total > 0">
          <pagination
            :total="total"
            :page.sync="pageNum"
            :limit.sync="pageSize"
            @pagination="handlePaginationChange"
          />
        </div>
      </div>
      <after-problem-dialog ref="afterProblemDialog" @success="updateProblem" />
    </div>
    <div class="flex_default_center" style="padding: 20px 0">
      <el-button
        class="primary-btn lang-but"
        v-if="!isLookOperate"
        size="small"
        type="primary"
        :disabled="isInputFocused ?  true : false"
        @click="handleSave"
      >
        保存
      </el-button>
      <!-- <el-button size="small" type="primary" plain  class="primary-btn lang-but" @click="back">
        {{ $route.query.operate === "look" ? "返回" : "取消" }}
      </el-button> -->
    </div>
  </div>
</template>

<script>
import listCurd from "@/mixins/listCurd";
import { getStorage, setStorageNew, getSession } from "@/util/localStor";
import {
  getCarDataByVinApi,
  afterFeedbackAddApi,
  afterFeedbackEditApi,
  preAfterSalesQuestionListApi,
  getVehicleAmountByOrderNumber,
} from "@/api/feedback";
import AfterProblemDialog from "./components/afterProblemDialog.vue";
export default {
  components: {
    AfterProblemDialog,
  },
  mixins: [listCurd],
  data() {
    return {
      countryList: Object.values(getSession("countryList")), // 国家列表
      pageName: {
        add: "新增反馈单",
        edit: "编辑反馈单",
        look: "查看反馈单",
      }, // 页面标题
      isLookOperate: false,
      qualityData: {}, // 质量反馈数据
      problemIndex: 0, // 操作问题列表索引
      queryParams: {
        feedbackFormId: "",
      }, // 查询参数
      listMethod: preAfterSalesQuestionListApi, // 获取表格数据api
      orderNum: "", //获取的订单号
      vinValid: "",
      type: "afterSalesDetail",
      isInputFocused: false,
    };
  },
  computed: {
    formRules() {
      return {
        vin: [{ required: true, message: "vin码不能为空" }],
        carModel: [{ required: true, message: "车型不能为空" }],
        carAttribute: [{ required: true, message: "车辆属性不能为空" }],
        saleDate: [{ required: true, message: "销售日期不能为空" }],
        productionDate: [{ required: true, message: "生产日期不能为空" }],
        drivingDistance: [{ required: true, message: "行驶里程不能为空" }],
      };
    },
  },
  created() {
    // 页面标题
    this.$route.meta.title = this.pageName[this.$route.query.operate];
    (this.isLookOperate = this.$route.query.operate === "look" ? true : false),
      sessionStorage.removeItem("goBackPath");
    // 质量反馈详情数据
    this.qualityData = getStorage("qualityData");
    // if (this.$route.query.customer) {
    //   const customer = JSON.parse(this.$route.query.customer);
    //   this.qualityData.customerId = customer.customerId;
    //   this.qualityData.customerName = customer.customerName;
    //   this.qualityData.customerCountry = customer.customerCountry;
    //   this.qualityData.customerAccountNum = customer.customerAccountNum;
    // }
    this.qualityData.delQuestionList = []; // 删除问题列表记录
    if (this.qualityData.feedbackFormId) {
      this.getList();
    }
    if (this.$route.meta.title === "编辑反馈单") {
      // this.getCarModel();
    }
    // // 获取订单号自动填充
    // if (this.qualityData.vin && this.qualityData.customerAccountNum) {
    //   this.getCarModel();
    // }
  },
  methods: {
    // 查询参数
    getParams() {
      const params = { ...JSON.parse(JSON.stringify(this.queryParams)) };
      params.feedbackFormId = this.qualityData.feedbackFormId;
      return {
        data: {
          ...params,
        },
        page: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        },
      };
    },
    // 返回
    back() {
      this.$router.go(-1);
    },
    // (新增 | 编辑)问题
    handleAddOrEdit(title, data = {}, index) {
      this.problemIndex = index ?? this.tableData.length;
      this.$refs.afterProblemDialog.init(
        title,
        {
          ...data,
          orderNum: this.qualityData.orderNum || data.orderNum,
          carTotal: this.qualityData.carTotal || data.carTotal,
        },
        this.orderNum
      );
    },
    // 查看问题
    handleLook(data) {
      setStorageNew("problemData", data);
      this.getSetItem();
      // 保存当前路由
      sessionStorage.setItem("goBackPath", this.$route.fullPath);
      this.$router.push("/problemDetail/allDetail");
    },
    // 修改问题
    updateProblem(data) {
      this.$set(this.tableData, this.problemIndex, data);
    },
    // 删除问题
    handleDelete({ questionId }, index) {
      this.$confirm(`是否确认删除?`, "提示", {
        cancelButtonClass: "confirm-btn-close",
        confirmButtonClass: "confirm-btn-confirm",
        type: "warning"
      }).then(() => {
        questionId && this.qualityData.delQuestionList.push({ questionId });
        this.tableData.splice(index, 1);
      })
      // questionId && this.qualityData.delQuestionList.push({ questionId });
      // this.tableData.splice(index, 1);
    },
    // 通过vin获取车型
    handleBlur() {
      this.isInputFocused = false;
    },
    handleFocus(){
      this.isInputFocused = true;
    },
    async getCarModel() {
      this.vinValid = "正在获取epc数据";
      const res = await getCarDataByVinApi({
        data: {
          vin: this.qualityData.vin,
        },
      });
      if (res.status == 0) {
        this.$set(this.qualityData, "carModel", res.data?.carModel || "");
        this.$set(this.qualityData, "orderNum", res.data?.orderNum || "");
        this.$set(
          this.qualityData,
          "productionDate",
          res.data?.vinCreated || ""
        );
        const res2 = await getVehicleAmountByOrderNumber(
          this.qualityData.orderNum
        );
        if (res2.status == 0) {
          this.qualityData.carTotal = res2.data || undefined;
          this.vinValid = "成功";
        } else {
          this.qualityData.carTotal = undefined;
          this.$DonMessage.error(res2.message);
          this.vinValid = "vin码对应的订单号未查询到订单数量";
        }
      } else { 
        this.$set(this.qualityData, "carModel", this.qualityData.carModel);
        this.$set(this.qualityData, "productionDate", this.qualityData.productionDate);
        this.$set(this.qualityData, "orderNum", "");
        this.qualityData.carTotal = undefined;
        this.$DonMessage.error(res.message);
        this.vinValid = "vin码不存在，未获取到车型和订单号";
      }
      // this.orderNum = res.data?.orderNum;
    },
    // 保存
    handleSave() {
      this.$refs.form.validate(async (valid, object) => {
        if (this.getRequiredValid(valid, object)){
          return
        }
        // if (this.vinValid != "成功") {
        //   this.$DonMessage.error(this.vinValid);
        //   return;
        // }
        try {
          const submitData = JSON.parse(JSON.stringify(this.qualityData));

          submitData.questionList = [];
          this.tableData.map((item) => {
            if (Array.isArray(item.maintenanceRecord)) {
              item.maintenanceRecord = item.maintenanceRecord.join(",");
            }
            if (!this.qualityData.carTotal) {
              this.qualityData.carTotal = item.carTotal
            }
            if (!this.qualityData.orderNum) {
              this.qualityData.orderNum = item.orderNum
            }
            submitData.questionList.push({ ...item, ...this.qualityData });
          });
          let res = {};
          if (submitData.feedbackFormId) {
            res = await afterFeedbackEditApi({ data: submitData });
          } else {
            res = await afterFeedbackAddApi({ data: submitData });
          }
          if (res.status == 0) {
            this.$DonMessage.success("保存成功");
            this.back();
          } else {
            this.$DonMessage.error(res.message);
          }
        } catch (error) {
          console.error(error);
        }
      });
    },
  },
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
